import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private hubConnection!: signalR.HubConnection;

  public solicitudCreada$ = new BehaviorSubject<any>(null);
  public solicitudActualizada$ = new BehaviorSubject<any>(null);

  constructor() {}

  conectar() {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${environment.socketURL}/hubs/solicitud`, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .build();

    this.hubConnection
      .start()
      .then(() => {})
      .catch((err) => {});

    this.hubConnection.on('SolicitudCreada', () => {
      this.solicitudCreada$.next(null);
    });

    this.hubConnection.on('SolicitudActualizada', () => {
      this.solicitudActualizada$.next(true);
    });
  }

  desconectar() {
    if (this.hubConnection) {
      this.hubConnection.stop();
    }
  }
}
